import React from 'react';
import cx from 'classnames';
// import PropTypes from 'prop-types'
import { AvatarStyled } from './styled';
import { MdPerson } from 'react-icons/md';

// วงกลม avatar ของแอดมิน: ถ้ามี src ใช้รูป ไม่มีก็แสดงไอคอนคนบนพื้นไล่สีน้ำเงิน
const Avatar = ({ theme_standard, src, size = 34 }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <AvatarStyled size={size}>
      <div className={customClass}>
        <div className="avatar">
          {src ? (
            <img className="avatar_img" alt="avatar" src={src} />
          ) : (
            <MdPerson className="avatar_icon" size={Math.round(size * 0.62)} />
          )}
        </div>
      </div>
    </AvatarStyled>
  );
};

Avatar.propTypes = {};

export default Avatar;
